// if (document.getElementById('vehicle-listings')) {
    // document.querySelectorAll('.search-listing').forEach(item => {
    //     item.classList.add('hidden');
    // });
    // document.querySelectorAll('.searchListing_skeleton').forEach(item => {
    //     item.classList.remove('hidden');
    // });
// }

document.addEventListener('lazybeforeunveil', function(e){
    if (e.target.classList.contains('vehicle-slider-swiper')) {
        new Swiper('#' + e.target.id, {
            // Optional parameters
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            lazy: {
                threshold: 50,
                loadPrevNext: true,
                loadPrevNextAmount: 1,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: false,
            watchSlidesVisibility: true,
            initialSlide: 0,
            preloadImages: false,
        });
    }
});